import React from 'react';
import LoadingImage from '../../assets/images/loader.svg';
import './AttachmentUploading.scss';

const AttachmentUploading = () => {
  return (
    <div className="uplaoding-background">
			<img className="loader" src={LoadingImage} alt="loading-icon" />
			<span className="loading-text">Uploading please wait...</span>
    </div>
  );
};

export default AttachmentUploading;



// WEBPACK FOOTER //
// ./src/components/AttachmentUploading/index.js